import { useAuth0 } from '@auth0/auth0-react';
import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import configuration from '../../../configuration';

export interface GeneratePromoCodeRequest {
    quantity: number;
}

export function useGeneratePromoCodes(
    options?: Omit<
        UseMutationOptions<
            void,
            AxiosError,
            GeneratePromoCodeRequest
        >,
        'mutationKey' | 'mutationFn'
    >,
) {
    const { getAccessTokenSilently } = useAuth0();
    return useMutation(
        async (request: GeneratePromoCodeRequest) => {            
            const token = await getAccessTokenSilently();
            axios.post(`${configuration.apiUrl}/donations/promo_code/generate`, request, {
                headers: {
                    'authorization': `bearer ${token}`
                }
            });

        }, options
    );
}